import React      from 'react';
import PropTypes from 'prop-types';

import * as S from './legal-ar-text.module.scss';

const LegalArText = ({btnText, chargeType}) => {
  let chargeTypeText =  'the price above';
  if(chargeType === 'paymentAdd') {
    chargeTypeText = 'the subscription price';
  }

  return (
    <p className={S.ArLegalText}>Automatic Renewal Authorization: By clicking &apos;{btnText},&apos; you authorize Quicken to automatically renew your subscription at the end of your term at the then-current subscription fee. You can turn off automatic renewal anytime in &apos;My Account&apos; or by contacting customer support. By subscribing, you agree to the <a href="/terms-of-use">Quicken Terms of Use</a> and <a href="/privacy">Privacy Policy</a>.
    </p>
  );
};

LegalArText.displayName = 'LegalArText';
LegalArText.propTypes = {
  btnText: PropTypes.string.isRequired,
  chargeType: PropTypes.string.isRequired,
};

export { LegalArText };
